import { render, staticRenderFns } from "./ImportsScreen.vue?vue&type=template&id=b63dc3fe&scoped=true&"
import script from "./ImportsScreen.vue?vue&type=script&lang=ts&"
export * from "./ImportsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ImportsScreen.vue?vue&type=style&index=0&id=b63dc3fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63dc3fe",
  null
  
)

export default component.exports